import React from 'react';
import Coupon from 'components/Coupons';

const Coupons = () => {
  return <Coupon />;
};

export default Coupons;
